import { defineMessages } from 'react-intl';

export const planMessages = defineMessages({
    'plan.title': {
        id: 'plan.title',
        defaultMessage: 'Plan',
        description: 'Browser page title for the plan page.',
    },
    'plan.care_plan': {
        id: 'plan.care_plan',
        defaultMessage: 'Plan',
        description: 'Page Title for the Plan page.',
    },
    'plan.care_plan_description': {
        id: 'plan.care_plan_description',
        defaultMessage:
            'Taking the mental health screening is the first step to evaluating your whole health and creating your personalized Plan.',
        description:
            'Explanation of the mental health screening and how it is related to the plan page.',
    },
    'plan.update_plan.update_plan': {
        id: 'plan.update_plan.update_plan',
        defaultMessage: 'Update plan',
        description: 'Button to update the plan.',
    },
    'plan.update_plan.goals': {
        id: 'plan.update_plan.goals',
        defaultMessage: 'Goals',
        description: 'Link to the onboarding page to select goals.',
    },
    'plan.update_plan.screening': {
        id: 'plan.update_plan.screening',
        defaultMessage: 'Screening',
        description: 'Link to the mental health screening.',
    },
    'plan.update_plan.conditions': {
        id: 'plan.update_plan.conditions',
        defaultMessage: 'Conditions',
        description: 'Link to the onboarding page to select conditions.',
    },
    'plan.update_plan.topics': {
        id: 'plan.update_plan.topics',
        defaultMessage: 'Topics',
        description: 'Link to the onboarding page to select topics.',
    },
    'plan.dailies': {
        id: 'plan.dailies',
        defaultMessage: 'Dailies',
        description: 'Section header for the dailies content.',
    },
    'plan.dailies_description': {
        id: 'plan.dailies_description',
        defaultMessage:
            'Get your day started or take a moment for mindfulness with today’s dailies.',
        description: 'Description of the dailies section.',
    },
    'plan.overview': {
        id: 'plan.overview',
        defaultMessage: 'Overview',
        description: 'Title for the overview section.',
    },
    'plan.all_recommendations': {
        id: 'plan.all_recommendations',
        defaultMessage: 'All Recommendations',
        description: 'Header for the section of all the recommended content.',
    },
    'plan.clinical_programs': {
        id: 'plan.clinical_programs',
        defaultMessage: 'Clinical Programs',
        description: 'Header for the clinical programs section.',
    },
    'plan.learn_why_recommended_simple': {
        id: 'plan.learn_why_recommended_simple',
        defaultMessage: 'Learn why this is a recommendation',
        description: 'Button to show why a program was recommended.',
    },
    'plan.learn_why_recommended': {
        id: 'plan.learn_why_recommended',
        defaultMessage: 'Learn why {title} was recommended',
        description: 'Button to show why a program was recommended.',
    },
    'plan.your_topic': {
        id: 'plan.your_topic',
        defaultMessage: 'Your Topic',
        description: 'Title for topic section.',
    },
    'plan.your_goal': {
        id: 'plan.your_goal',
        defaultMessage: 'Your Goal',
        description: 'Title for goal section.',
    },
    'plan.your_condition': {
        id: 'plan.your_condition',
        defaultMessage: 'Your Condition',
        description: 'Title for condition section.',
    },
    'plan.learn_why_modal.top_recommendation': {
        id: 'plan.learn_why_modal.top_recommendation',
        defaultMessage: 'Top Recommendation',
        description: 'Header introducing the top recommendation.',
    },
    'plan.learn_why_modal.additional_recommendations': {
        id: 'plan.learn_why_modal.additional_recommendations',
        defaultMessage: 'Additional Recommendations',
        description: 'Header introducing additional recommendations.',
    },
    'plan.learn_why_modal.program': {
        id: 'plan.learn_why_modal.program',
        defaultMessage: 'program',
        description: 'A collection of clinical cotent.',
    },
    'plan.learn_why_modal.content': {
        id: 'plan.learn_why_modal.content',
        defaultMessage: 'content',
        description: 'A piece of audio or video',
    },
    'plan.learn_why_modal.subtitle': {
        id: 'plan.learn_why_modal.subtitle',
        defaultMessage:
            'This {contentType} has been selected based on the information you’ve shared with Calm Health.',
        description: 'Explanation of why a program was recommended.',
    },
    'plan.learn_why_modal.anxiety_pod.title': {
        id: 'plan.learn_why_modal.anxiety_pod.title',
        defaultMessage: 'Anxiety',
        description: 'Anxiety level of the user.',
    },
    'plan.learn_why_modal.anxiety_pod.subtitle': {
        id: 'plan.learn_why_modal.anxiety_pod.subtitle',
        defaultMessage:
            'Your {date} results indicate you may have {level} anxiety.',
        description: 'Result of the anxiety screening.',
    },
    'plan.learn_why_modal.depression_pod.title': {
        id: 'plan.learn_why_modal.depression_pod.title',
        defaultMessage: 'Depression',
        description: 'Depression',
    },
    'plan.learn_why_modal.depression_pod.subtitle': {
        id: 'plan.learn_why_modal.depression_pod.subtitle',
        defaultMessage:
            'Your {date} results indicate you may have {level} depression.',
        description: 'Result of the depression screening.',
    },
    'plan.learn_why_modal.conditions_pod.title.some': {
        id: 'plan.learn_why_modal.conditions_pod.title.some',
        defaultMessage: 'Matches {matching} of Your {total} Conditions',
        description: 'Explanation of why a program was recommended.',
    },
    'plan.learn_why_modal.conditions_pod.title.all': {
        id: 'plan.learn_why_modal.conditions_pod.title.all',
        defaultMessage: 'Matches all of Your Conditions',
        description: 'Explanation of why a program was recommended.',
    },
    'plan.learn_why_modal.topics_pod.title.some': {
        id: 'plan.learn_why_modal.topics_pod.title.some',
        defaultMessage: 'Matches {matching} of Your {total} Topics',
        description: 'Explanation of why a program was recommended.',
    },
    'plan.learn_why_modal.topics_pod.title.all': {
        id: 'plan.learn_why_modal.topics_pod.title.all',
        defaultMessage: 'Matches all of Your Topics',
        description: 'Explanation of why a program was recommended.',
    },
    'plan.learn_why_modal.goals_pod.title.some': {
        id: 'plan.learn_why_modal.goals_pod.title.some',
        defaultMessage: 'Matches {matching} of Your {total} Goals',
        description: 'Explanation of why a program was recommended.',
    },
    'plan.learn_why_modal.goals_pod.title.all': {
        id: 'plan.learn_why_modal.goals_pod.title.all',
        defaultMessage: 'Matches all of Your Goals',
        description: 'Explanation of why a program was recommended.',
    },
    'plan.learn_why_modal.age_gender_pod.title': {
        id: 'plan.learn_why_modal.age_gender_pod.title',
        defaultMessage: 'Age and Gender',
        description: 'Explanation of why a program was recommended.',
    },
    'plan.learn_why_modal.age_pod.title': {
        id: 'plan.learn_why_modal.age_pod.title',
        defaultMessage: 'Age',
        description: 'Explanation of why a program was recommended.',
    },
    'plan.learn_why_modal.gender_pod.title': {
        id: 'plan.learn_why_modal.gender_pod.title',
        defaultMessage: 'Gender',
        description: 'Explanation of why a program was recommended.',
    },
    'plan.learn_why_modal.footer': {
        id: 'plan.learn_why_modal.footer',
        defaultMessage:
            'Please be aware that while this {contentType} can support you, it’s not intended to replace the role of a mental health provider and/or medication, especially for those with severe conditions.',
        description: 'Disclaimer for the recommendation.',
    },
    'plan.learn_why_modal.view_program': {
        id: 'plan.learn_why_modal.view_program',
        defaultMessage: 'View Program',
        description: 'Button to view the recommended program.',
    },
    'plan.learn_why_modal.view': {
        id: 'plan.learn_why_modal.view',
        defaultMessage: 'View',
        description: 'Button to view the recommended content.',
    },
    plan_no_recommendations_pod: {
        id: 'plan.no_recommendations_pod',
        defaultMessage: 'No recommendations yet',
        description: 'Text to display when the user has no recommendations.',
    },
    plan_no_recommendations_pod_subtitle: {
        id: 'plan.no_recommendations_pod_subtitle',
        defaultMessage:
            'The more you tell us about yourself, the more we can personalize your Plan for you.',
        description: 'Explanation of the recommendations section.',
    },
    plan_no_recommendations_pod_subtitle_concierge: {
        id: 'plan.no_recommendations_pod_subtitle_concierge',
        defaultMessage:
            "We couldn't find anything for you this time. Try again by adding more details about your mental health goals.",
        description:
            'Explanation of the recommendations section for concierge.',
    },
    'plan.no_recommendation_header.1': {
        id: 'plan.no_recommendation_header.1',
        defaultMessage: 'Tell us more about you',
        description: 'Prompt to get the user to update their information.',
    },
    'plan.no_recommendation_header.2': {
        id: 'plan.no_recommendation_header.2',
        defaultMessage: 'Take a deep breath',
        description: 'Prompt to get the user to relax.',
    },
    'plan.no_recommendation_subheader.1': {
        id: 'plan.no_recommendation_subheader.1',
        defaultMessage:
            'Your Plan will update dynamically as you tell us more information. Try changing your goals, updating your issues or conditions, or taking the mental health screening.',
        description: 'Prompt to get the user to update their information.',
    },
    'plan.no_recommendation_subheader.2': {
        id: 'plan.no_recommendation_subheader.2',
        defaultMessage:
            'You’re doing great. We recommend checking out our mindfulness content. Here are today’s Dailies and a link to explore our library of Calm content below.',
        description: 'Introduction of Calm Health content.',
    },
    noRecommendationSubheaderMindshift: {
        id: 'plan.no_recommendation_subheader_mindshift',
        defaultMessage:
            'Based on what you’ve told us, you’re doing great. We recommend checking out our Mindshift content, for a quick burst of learning and inspiration around how our bodies and minds work. Here are the most recent Mindshifts, and a link to explore our library of Calm content below.',
        description: 'Introduction of Mindshift content.',
    },
    'plan.start_with_header': {
        id: 'plan.start_with_header',
        defaultMessage: 'Start with {programTitle}',
        description: 'Call to action to start a program.',
    },
    'plan.featured_content_header': {
        id: 'plan.featured_content_header',
        defaultMessage: 'Your journey starts here.',
        description:
            'Heading shown on the plan page when a featured_content recommendation is present and BE has not provided a topLevelHeadline.',
    },
    'plan.start_with_subheader': {
        id: 'plan.start_with_subheader',
        defaultMessage:
            'Here’s your first recommended program with Calm Health.',
        description: 'Introduction to the first recommended program.',
    },
    'plan.next_up_header': {
        id: 'plan.next_up_header',
        defaultMessage: 'Next Up: {programTitle}',
        description: 'Header for the next recommended program.',
    },
    'plan.next_up_subheader': {
        id: 'plan.next_up_subheader',
        defaultMessage:
            'You have already joined {joinedPrograms}. We recommend joining this program after you complete the others.',
        description: 'Displayed to dissuade the user from starting a program.',
    },
    'plan.top_recommendation_joined_header.1': {
        id: 'plan.top_recommendation_joined_header.1',
        defaultMessage: 'Continue with your Journey',
        description:
            'Header for the top recommendation when the user has already joined the program.',
    },
    'plan.top_recommendation_joined_header.2': {
        id: 'plan.top_recommendation_joined_header.2',
        defaultMessage: 'Keep The Momentum Going!',
        description: 'Encouragement to keep going with the program.',
    },
    'plan.top_recommendation_joined_header.3': {
        id: 'plan.top_recommendation_joined_header.3',
        defaultMessage: 'You’re On the Right Track',
        description: 'Encouragement to keep going with the program.',
    },
    'plan.top_recommendation_joined_header.4': {
        id: 'plan.top_recommendation_joined_header.4',
        defaultMessage: 'You’re on the right path!',
        description: 'Encouragement to keep going with the program.',
    },
    'plan.top_recommendation_joined_header.5': {
        id: 'plan.top_recommendation_joined_header.5',
        defaultMessage: 'You’ve got this!',
        description: 'Encouragement to keep going with the program.',
    },
    'plan.top_recommendation_joined_subheader.1': {
        id: 'plan.top_recommendation_joined_subheader.1',
        defaultMessage:
            'The {programTitle} program is still our recommended next step.',
        description: 'Introduction to the top recommended program.',
    },
    'plan.top_recommendation_joined_subheader.2': {
        id: 'plan.top_recommendation_joined_subheader.2',
        defaultMessage: 'Keep making progress with {programTitle}.',
        description: 'Encouragement to keep going with the program.',
    },
    'plan.top_recommendation_joined_subheader.3': {
        id: 'plan.top_recommendation_joined_subheader.3',
        defaultMessage:
            'You’ve already joined {programTitle}, which remains our top recommendation for you.',
        description:
            'Header for the top recommendation when the user has already joined the program.',
    },
    'plan.top_recommendation_joined_subheader.4': {
        id: 'plan.top_recommendation_joined_subheader.4',
        defaultMessage:
            'Our top recommendation is a program you’ve already joined: {programTitle}.',
        description:
            'Text to display when the user has already joined the program.',
    },
    'plan.top_recommendation_retake_header.1': {
        id: 'plan.top_recommendation_retake_header.1',
        defaultMessage: 'Change Doesn’t Happen Overnight',
        description: 'Encouragement to keep going with the program.',
    },
    'plan.top_recommendation_retake_header.2': {
        id: 'plan.top_recommendation_retake_header.2',
        defaultMessage: 'Keep Building Resilience',
        description: 'Encouragement to take the program again.',
    },
    'plan.top_recommendation_retake_header.3': {
        id: 'plan.top_recommendation_retake_header.3',
        defaultMessage: 'Practice Makes Progress',
        description: 'Encouragement to take the program again.',
    },
    'plan.top_recommendation_retake_header.4': {
        id: 'plan.top_recommendation_retake_header.4',
        defaultMessage: 'Let’s Try Again!',
        description: 'Encouragement to take the program again.',
    },
    'plan.top_recommendation_retake_header.5': {
        id: 'plan.top_recommendation_retake_header.5',
        defaultMessage: 'Repetition Is a Good Thing',
        description: 'Encouragement to take the program again.',
    },
    'plan.top_recommendation_retake_subheader.1': {
        id: 'plan.top_recommendation_retake_subheader.1',
        defaultMessage:
            'We recommend taking the {programTitle} program again! You can review the key lessons and keep building your resilience.',
        description: 'Encouragement to take the program again.',
    },
    'plan.top_recommendation_retake_subheader.2': {
        id: 'plan.top_recommendation_retake_subheader.2',
        defaultMessage:
            'We recommend taking the {programTitle} program again, to help reinforce key concepts.',
        description: 'Ecouragement to take the program again.',
    },
    'plan.top_recommendation_retake_subheader.3': {
        id: 'plan.top_recommendation_retake_subheader.3',
        defaultMessage:
            'We recommend taking the {programTitle} program again. This will help reinforce key lessons.',
        description: 'Encouragement to take the program again.',
    },
    'plan.learn_why': {
        id: 'plan.learn_why',
        defaultMessage: 'Learn why this program is your top recommendation ›',
        description: 'Title above the top recommendation.',
    },
    'plan.calm_clinical_recommendations': {
        id: 'plan.calm_clinical_recommendations',
        defaultMessage: 'Calm Clinical Recommendations',
        description: 'Header introducing the clinical recommendations.',
    },
    'plan.calm_clinical_recommendations_subtitle': {
        id: 'plan.calm_clinical_recommendations_subtitle',
        defaultMessage:
            'Select the info icon to learn why we recommend these additional programs.',
        description: 'Prompt to learn more about the clinical recommendations.',
    },
    'plan.calm_additional_recommendations': {
        id: 'plan.calm_additional_recommendations',
        defaultMessage: 'Additional Recommendations',
        description: 'Title above the additional recommendations.',
    },
    'plan.calm_additional_recommendations_subtitle': {
        id: 'plan.calm_additional_recommendations_subtitle',
        defaultMessage:
            'Here are additional recommendations that match your topics and goals.',
        description: 'Introducing the additional recommendations.',
    },
    'plan.additional_recommendations_view_all': {
        id: 'plan.additional_recommendations_view_all',
        defaultMessage: 'View All {title} Content ›',
        description: 'Button to view all of the content in a section.',
    },
    'plan.have_not_found_what_you_are_looking_for': {
        id: 'plan.have_not_found_what_you_are_looking_for',
        defaultMessage: 'Haven’t found what you’re looking for?',
        description: 'Prompt to get the user to explore more content.',
    },
    'plan.discover': {
        id: 'plan.discover',
        defaultMessage: 'Discover',
        description: 'Header for the discover section.',
    },
    'plan.explore_calm': {
        id: 'plan.explore_calm',
        defaultMessage: 'Explore Calm',
        description: 'Button to explore the Calm content.',
    },
});

export default planMessages;
